module.exports = __webpack_public_path__ + "static/img/zero.5af2a9f.png";